import { render } from "./diagnosisItem.vue?vue&type=template&id=ad272d10&scoped=true"
import script from "./diagnosisItem.vue?vue&type=script&lang=js"
export * from "./diagnosisItem.vue?vue&type=script&lang=js"

import "./diagnosisItem.vue?vue&type=style&index=0&id=ad272d10&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad272d10"]])

export default __exports__